import { currencyFormatRp } from 'helpers/currency'
import { type MasterPayrollValidateDetailDataInterface } from 'features/Enterprise/Payroll/types'

import { REGULAR_PAYSLIP_INCOME_COLUMN_METAS } from './regularPayslipTableColumns'

export const VALIDATE_PAYSLIP_ALERT_MESSAGE =
  'Kamu dapat edit detail hanya pada Jumlah Hari dan Pendapatan Lainnya.'

export const VALIDATE_PAYSLIP_ALERT_MESSAGE_INCENTIVE =
  'Kamu dapat edit detail hanya pada Incentive.'

const parseNumber = (value: string | number | null | undefined): number => Number(value ?? 0)

export const formatMoney = (value: string | number | null | undefined): string =>
  currencyFormatRp(parseNumber(value))

export const formatTextLabel = (value: string): string =>
  value
    .split('_')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ')

export const getTransferInfo = (
  detail: MasterPayrollValidateDetailDataInterface | null,
): string => {
  if (!detail) return '-'
  const { nomor_rekening, nama_bank, nama_pemilik_rekening } = detail.informasi_transfer
  const primary = [nomor_rekening, nama_bank].filter(Boolean).join(' ')
  const owner = nama_pemilik_rekening ? `a/n ${nama_pemilik_rekening}` : ''
  return [primary, owner].filter(Boolean).join(' ') || '-'
}

type InfoFieldType = { label: string; value: string }

export const getInfoFields = (
  payrollIdFallback: string,
  staffName: string,
  detail: MasterPayrollValidateDetailDataInterface | null,
): InfoFieldType[] => {
  const staffIdDisplay =
    detail?.staff_info?.staff_id != null
      ? String(detail.staff_info.staff_id)
      : payrollIdFallback || '-'

  const locationDisplay =
    detail?.location_name?.trim() ||
    (detail?.location_id != null ? `Lokasi ID - ${detail.location_id}` : '-')

  return [
    { label: 'Nama Pegawai', value: detail?.staff_info?.name || staffName || '-' },
    { label: 'ID Pegawai', value: staffIdDisplay },
    {
      label: 'Lokasi',
      value: locationDisplay,
    },
    { label: 'Periode Komisi', value: detail?.periode_komisi || '-' },
    { label: 'NIK KTP', value: detail?.staff_info?.nik || '-' },
    { label: 'Informasi Transfer', value: getTransferInfo(detail) },
  ]
}

export const getIncomeRows = (
  detail: MasterPayrollValidateDetailDataInterface | null,
): string[][] =>
  detail?.pendapatan?.map((item) => [
    item.role || '-',
    ...REGULAR_PAYSLIP_INCOME_COLUMN_METAS.map((meta) =>
      formatMoney(item[meta.pendapatanAmountKey]),
    ),
  ]) ?? []
